var React = require('react');

function IconIncrease (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"icon - increase","d":"m3 0 3 4H0z","style":{"fill":"#71c184"}}));
}

IconIncrease.defaultProps = {"width":"6","height":"4","viewBox":"0 0 6 4"};

module.exports = IconIncrease;

IconIncrease.default = IconIncrease;
